export enum PaymentOption {
  MonthlyThreshold = 'Monthly Threshold',
  NoPay = 'No Pay',
}
